<template>
    <div>
        <div v-if="!editMode || (editMode && item.id)" class="row">
            <div class="col-xl-12 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 form-group">
                                <label for="roles">Roles</label>
                                <v-select
                                    :value="item.roles"
                                    :options="ALL_ROLES"
                                    :clearable="false"
                                    label="text"
                                    :reduce="option => option.value"
                                    :class="{
                                        'is-invalid': getError('roles')
                                    }"
                                    multiple
                                    @input="onRolesChange"
                                />
                                <div class="invalid-feedback">
                                    {{ getError('roles') }}
                                </div>
                            </div>
                            <form-input
                                v-model="item.email"
                                label="Email"
                                :error-message="getError('email')"
                            />
                            <form-input
                                v-model="item.firstName"
                                label="First name"
                                :error-message="getError('firstName')"
                                class-name="col-sm-6 col-12 form-group"
                            />
                            <form-input
                                v-model="item.lastName"
                                label="Last name"
                                :error-message="getError('lastName')"
                                class-name="col-sm-6 col-12 form-group"
                            />
                            <form-input
                                v-model="item.nickname"
                                label="Nickname"
                                :error-message="getError('nickname')"
                                class-name="col-sm-6 col-12 form-group"
                            />
                            <form-input
                                v-model="item.info"
                                label="Info"
                                :error-message="getError('info')"
                                component-type="textarea"
                            />
                            <div class="col-12 form-group">
                                <label for="avatar">Avatar</label>
                                <media-chooser
                                    v-model="item.avatarId"
                                    type="image"
                                    id-only
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <small v-if="!editMode" class="pl-3">
                Note: Users created through CMS are automatically verified.
            </small>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseForm from '@/components/elements/BaseForm';

export default {
    extends: BaseForm,

    computed: {
        ...mapGetters({
            ALL_ROLES: 'roles/ALL_ROLES'
        })
    },

    async mounted() {
        if (this.editMode) {
            this.item.roles = this.item.roles.map(role => role.name);
        }
    },

    methods: {
        onRolesChange(value) {
            this.item.roles = value;
        }
    }
};
</script>
